// extracted by mini-css-extract-plugin
var _1 = "Header__main--dVl7p";
var _2 = "Header__quadBg--Ncgka";
var _3 = "Header__quadBorder--KLRN5";
var _4 = "Header__quadWrapper--Ygw0y";
export { _1 as "main", _2 as "quadBg", _3 as "quadBorder", _4 as "quadWrapper" }
